const translations = {
  "requestCall.leaveContactInformation": "დაგვიტოვე საკონტაქტო ინფორმაცია",
  "requestCall.subTitle":
    "პროდუქტის შესახებ დამატებითი ინფორმაციის მისაღებად დაგვიტოვე შენი საკონტაქტო ინფორმაცია",
  "requestCall.name": "სახელი",
  "requestCall.phoneNumber": "ტელეფონის ნომერი",
  "requestCall.email": "ელ.ფოსტა",
  "requestCall.comment": "კომენტარი",
  "requestCall.acceptedMarketingText":
    "ვეთანხმები პირდაპირი მარკეტინგის მიზნებისათვის კანონმდებლობით ნებადართულ ფარგლებში და წესით ",
  "requestCall.acceptedMarketingLink": "პერსონალური მონაცემების დამუშავებას",
  "requestCall.acceptedPersonalInformationText":
    "ვეთანხმები პერსონალური მონაცემების ",
  "requestCall.acceptedPersonalInformationLink": "დამუშავების წესებს",
  "requestCall.send": "გაგზავნა",
  "requestCall.requiredField": "მითითებული ველის შევსება სავალდებულოა",
  "requestCall.phoneNumberError": "შეიყვანეთ სწორი ნომერი",
  "requestCall.emailError": "შეიყვანეთ სწორი ელ.ფოსტა",
  "requestCall.pleaseAgreeDataProcessingRule":
    "გთხოვთ, დაეთანხმოთ მონაცემთა დამუშავების წესებს",
  "requestCall.successMessage":
    " შენი შეტყობინება მიღებულია! იმედი L-ის წარმომადგენელი დაგიკავშირდება",
  "requestCall.onPhoneNumber": "საკონტაქტო ნომერზე",
  "requestCall.onEmail": "ელექტრონულ ფოსტაზე",
  "requestCall.preferContactText": "სად გირჩევნიათ დაგიკავშირდეთ?",
};

export default translations;
